export default __webpack_public_path__ + "static/media/app_logo.fd86d246.svg";